export const audio8 = "1NGK6QGYLmjHpXzWwmvLqF8VkQOBRMtfA";
export const intro8 = "";

export const vocab8 = {
    every: ['měi', '每'],
    day: ['tiān', '天'],
    he: ['tā', '他'],
    his: ['tā', '他'],
    of: ['de', '的'],
    friends: ['péngyǒumen', '朋友们'],
    goes: ['qù', '去'],
    school: ['xuéxiào', '学校'],
    study: ['xuéxí', '学习'],
    together: ['yīqǐ', '一起'],
    play: ['wánshuǎ', '玩耍'],
    and: ['hé', '和'],
    they: ['tāmen', '他们'],
    also: ['yě', '也'],
    eat: ['chī', '吃'],
    lunch: ['wǔfàn', '午飯'],
    this: ['zhè', '这'],
    is: ['shì', '是'],
    their: ['tāmen', '他们'],
    favorite: ['zuì xǐhuān', '最喜欢'],
    most: ['zuì', '最'],
    liked: ['xǐhuān', '喜欢'],
    time: ['shíjiān', '时间'],
    to: ['', ''],
    '.': ['.', '。'],
    ',': [',', '，'],
};

export const lesson8 = [
    {
        literal: ['every', 'day', ',', 'he', 'goes', 'school', '.'],
        translated: ['every', 'day', 'he', 'goes', 'to', 'school', '.']
    },
    {
        literal: ['he', 'and', 'his', 'of', 'friends', 'together', 'study', ',', 'play', '.'],
        translated: ['he', 'and', 'his', 'friends', 'study', 'together', 'and', 'play', 'together', '.']
    },
    {
        literal: ['they', 'also', 'together', 'eat', 'lunch', ','],
        translated: ['they', 'also', 'eat', 'lunch', 'together', ',']
    },
    {
        literal: ['this', 'is', 'their', 'most', 'liked', 'time', '.'],
        translated: ['this', 'is', 'their', 'favorite', 'time', '.']
    },
];